import * as React from "react";
import { type IconProp } from "@fortawesome/fontawesome-svg-core";
import { isIconLookup, isIconName, type ShopfrontIconProps } from "./FontAwesomeLight";

export default class FontAwesomeSolid extends React.Component<ShopfrontIconProps> {
    public render(): React.ReactNode {
        const {
            icon,
            pulse,
            spin,
            className,
            ...props
        } = this.props;

        let iconArray: IconProp;

        if(isIconName(icon)) {
            iconArray = [ "fas", icon ];
        } else if(isIconLookup(icon)) {
            iconArray = [ icon.prefix, icon.iconName ];
        } else {
            iconArray = icon;
        }

        const classes = [ iconArray[0], `fa-${iconArray[1]}`, "fa-fw", "shopfront-icon" ];

        if(className) {
            classes.push(className);
        }

        if(spin) {
            classes.push("fa-spin");
        }

        if(pulse) {
            classes.push("fa-pulse");
        }

        return <i
            {...props}
            className={classes.join(" ")}
        />;
    }
}
